<script setup lang="ts">
import Banner from "@/components/shared/Banner.vue"

const pathname = window.location.pathname
const showBanner =
  !pathname.includes("benchmarking") && !pathname.includes("dashboard")

const year = new Date().getFullYear()
</script>

<template>
  <Banner
    v-if="showBanner"
    :id="`xy-${year}-survey-banner`"
    link="/benchmarking"
    :hide-duration="7"
    btn-text="Fill It Out"
    :title="`Benchmarking Survey ${year}`"
    description="Submit your survey now!"
  />
</template>
